import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";

import Api from '../../gd/api/api';

import Smile from './components/smile';

import FormManager from '../../gd-form/common/form-manager';
import Textarea from '../../../core/gd-form/form-element/textarea/textarea';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit';

import { when } from 'simply-deferred';
import RateExperienceFeature from "./components/feature";

class ModalUpgradeProfessional extends BaseComponent {

    static propTypes = {
        params: PropTypes.shape({
            // myWorkId: PropTypes.any
            // callback : callback
        })
    }

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            rating: this.props.initRating
        };

        this.displayName = 'ModalUpgradeProfessional';
        this.messages = ['',
            'We are extremely sorry to hear that. Please let us know what went wrong so we could fix it.',
            'We are very sorry to hear that. Please let us know how we can improve your experience.',
            'Thank you for your feedback, what can we do to improve?',
            'Glad to hear! Is there anything we can do to make your experience even better?',
            'So happy to hear! Is there anything we can do to make your experience even better?',
        ];

        this._bind('onSubmit', 'onSmileClick');

        const initFormData = {
            message: ''
        };

        const formStructure = {
            fields: {

                interface: 'input',
                functionality: 'input',
                newFeatures: 'input',
                integrations: 'input',

                message: {
                    type: 'input',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    componentDidMount() {
        const cssLoader = gd.skin.loadDeferred("modals", "rate-experience");

        when(cssLoader).then(
            this.setState({
                isLoading: false
            })
        );
    }

    onSubmit(values) {

        const workOn = [];
        values.interface && workOn.push("Interface");
        values.functionality && workOn.push("Existing functionality");
        values.newFeatures && workOn.push("New features");
        values.integrations && workOn.push("Integrations");
        const params = {
            workOn: workOn
        };

        const request = Api.Support.rateUserExperience(this.state.rating,values.message, null, params);
        request.done((response)=>{
            gd.growl.success("Thank you for your feedback");
            gd.modal.hide();

            gd.user.clientData.rateExperience = false;
            gd.user.saveClientData();

            if (this.props.params.callback) {
                this.props.params.callback()
            }

        })
    }

    onSmileClick(rating) {
        this.setState({
            rating: rating
        })
    }

    reRender = () => {
        this.setState({reRender: true});
    };

    renderLoading() {
        return (
            <div>Loading...</div>
        )
    }

    renderForm() {
        const {rating} = this.state;
        const message = this.messages[rating];

        return (
            <div>
                <div className="desc2">{message}</div>

                <div className="suggestion">

                    <RateExperienceFeature form={this.form} name="interface" title="Improve user interface" reRender={this.reRender}/>
                    <RateExperienceFeature form={this.form} name="functionality" title="Enhance existing functionality" reRender={this.reRender}/>
                    <RateExperienceFeature form={this.form} name="newFeatures" title="Add new features" reRender={this.reRender}/>
                    <RateExperienceFeature form={this.form} name="integrations" title="More integrations" reRender={this.reRender}/>
                    <div className="cf"></div>
                </div>



                <Textarea size="big" form={this.form} name="message" placeholder="Comments" />
                <div className="actions">
                    <ButtonSubmitDeprecated form={this.form} label="Submit" />
                </div>
            </div>
        )
    }

    render() {
        const {isLoading, rating} = this.state;

        if (isLoading) {
            return this.renderLoading();
        }

        return (
            <div>

                <div className="desc1">
                    We would appreciate if you could take a moment to share some feedback on your experience with GoodDay so far. This will help us to improve and release new features.
                </div>

                <div className="smiles">
                    <Smile value="1" isSelected={(rating===1)} onClick={this.onSmileClick.bind(this,1)} />
                    <Smile value="2" isSelected={(rating===2)} onClick={this.onSmileClick.bind(this,2)}/>
                    <Smile value="3" isSelected={(rating===3)} onClick={this.onSmileClick.bind(this,3)}/>
                    <Smile value="4" isSelected={(rating===4)} onClick={this.onSmileClick.bind(this,4)}/>
                    <Smile value="5" isSelected={(rating===5)} onClick={this.onSmileClick.bind(this,5)}/>
                </div>

                {rating && this.renderForm()}
            </div>
        );
    }
}

module.exports = ModalUpgradeProfessional;